@if (print && filter) {
<app-print-filter-data [filter]="filter" />
} @if (dataSummary && !dataSummary.pages.length && !wordcloud.length && !dataEvolution &&
!dataRanking.length) {
<div class="empty">
  <p>Não há dados para exibir</p>
</div>
}

<!-- Resumo -->
@if (dataSummary) { @for (page of dataSummary.pages; track page.pageNumber) {
@for (question of page.questions; track $index) {
<div class="card">
  <p class="title">{{ question.title }}</p>
  <hr />
  <div class="count">
    <img src="assets/img/account_circle.png" alt="account_circle" />
    <p>{{ question.totalResponses }} respostas</p>
  </div>

  <div class="chart">
    @if (question.satisfactionPercentage) {
    <div class="satisfacao">
      <p>Satisfação</p>
      <h1>{{ question.satisfactionPercentage }}%</h1>
    </div>
    }
    <div class="bar-chart">
      <app-custom-bar-chart
        [dataType]="
          question.satisfactionPercentage
            ? chartColorsEnum.colorsWeight
            : chartColorsEnum.singleColor
        "
        [data]="question.answerDetail"
      />
    </div>
  </div>
</div>
} } }

<!-- Evolução -->
@if(dataEvolution) {
<app-line-chart [labels]="dataEvolution.labels" [datasets]="dataEvolution" />
}

<!-- Ranking -->
@for (rank of dataRanking; track $index) { @for (dailyData of
rank.dailyManagerialList; track $index) { @if
(dailyData.dailyManagerialData.length) {
<div class="card">
  <p class="title red-brackground">Ranking {{ dailyData.type }}</p>
  <hr />
  <p class="title">{{ dataEvolution ? dataEvolution.title : "" }}</p>
  <hr />
  <div class="count">
    <img src="assets/img/account_circle.png" alt="account_circle" />
    <p>{{ dailyData.total }} respostas</p>

    <img class="scales" src="assets/img/Scales.png" alt="scales" />
    <p>{{ dailyData.total }}% Média geral</p>
  </div>

  <div class="chart">
    <div class="bar-chart">
      <app-custom-bar-chart
        [dataType]="chartColorsEnum.singleColor"
        [data]="dailyData.dailyManagerialData"
      />
    </div>
  </div>
</div>
} } }

<!-- Wordcloud -->
@if(wordcloud.length){
<div class="card wordcloud">
  <div class="card-header">
    <p class="title">Wordcloud</p>
    <hr />
    <p class="title">{{ dataEvolution ? dataEvolution.title : "" }}</p>
    <p>{{ countWordclound }} respostas</p>

    <hr />
  </div>

  <app-word-cloud [data]="wordcloudChart" />

  <div class="word-table">
    <app-word-table [data]="wordcloud" [count]="countWordclound" />
  </div>
</div>
}
